import common from "../common";
import GelButton from "../ui/gel/GelButton";
import GelScene from "../ui/gel/GelScene";
import moment from "moment";

export default class ResultScene extends GelScene {
    constructor(score = 0, total = 10, xp = {from: 0, to: 1, xp: 0, target: 1}, victory = false, answers = []) {
        super();

        this._score = score;
        this._total = total;
        this._xp = xp;
        this._victory = victory;

        this._panel = null;
        this._progress = null;
        this._shields = [];
        this._answers = answers;

        this._currentTutorialVO = null;

        this._particleLayer = null;
        this._fairyDustEmitter = null;
    }

    init() {
        super.init();

        const bg = new PIXI.Sprite(P3.assets.texture("ui_results_bg1"));
        bg.width = common.STAGE_WIDTH;
        this.addChild(bg);

        this.initHomeButton(GelButton.TAB_INDEX_LEVEL_0);
        this.initMuteButton(GelButton.TAB_INDEX_LEVEL_0 + 1);
        this.initSettingsButton(GelButton.TAB_INDEX_LEVEL_0 + 2);
        this.initPlayButton(GelButton.TAB_INDEX_LEVEL_3, GelButton.POSITION_BOTTOM_RIGHT);

        this._particleLayer = new PIXI.Container();
        this.addChild(this._particleLayer);

        const config = P3.assets.json("particle_fairy_dust");
        this._fairyDustEmitter = new PIXI.particles.Emitter(this._particleLayer, [
            P3.assets.texture("particle_divide"),
            P3.assets.texture("particle_minus"),
            P3.assets.texture("particle_multiply"),
            P3.assets.texture("particle_plus")
        ], config);

        this._fairyDustEmitter.emit = true;
        this._fairyDustEmitter.updateOwnerPos(common.STAGE_WIDTH * 0.5, 0);

        if (common.location.challenge)
        {
            this.initTitle("Results - " + common.date, 32);
        }
        else
        {
            this.initTitle("Results");
        }

        this.initPanel();
        this.initProgressBar();
    }

    destroy() {
        this._currentTutorialVO && this._currentTutorialVO.destroy();

        this._fairyDustEmitter.destroy();

        super.destroy();
    }

    show() {
        super.show();

        this._currentTutorialVO && this._currentTutorialVO.play();
    }

    hide() {
        super.hide();

        this._currentTutorialVO && this._currentTutorialVO.pause();
    }

    resize() {
        super.resize();

        this._fairyDustEmitter.spawnRect = new PIXI.Rectangle(-P3.View.width * 0.5, 0, P3.View.width, P3.View.height);
    }

    appear() {
        super.appear();

        if (common.location.training/* && !isEdge18()*/) {
            let index = 0;
            const vos = ["vo_queen_126", "vo_queen_127b", "vo_queen_128"];

            function next() {
                if (index < vos.length) {
                    this._currentTutorialVO = P3.audio.playSound(vos[index++]);
                    if (this._currentTutorialVO) {
                        this._currentTutorialVO.signals.end.once(() => next.call(this));
                    } else {
                        next.call(this);
                        return;
                    }

                    if (common.gmi.getAllSettings().subtitles) {
                        const data = P3.assets.json("subtitles");
                        common.subtitles.show(data[this._currentTutorialVO.howl.name] ?
                            data[this._currentTutorialVO.howl.name] : this._currentTutorialVO.howl.name, this._currentTutorialVO.howl.duration());
                    }
                } else {
                    this._currentTutorialVO = null;
                }
            }

            next.call(this);
        } else {
            if (common.difficulty.levelChange === 1) {
                this.playShieldLevelVO();
            } else if (common.difficulty.levelChange === -1) {
                P3.audio.playVO("vo_queen_135", 1, true);
            } else {
                P3.audio.playVO(["vo_queen_136f", "vo_queen_137", "vo_queen_191b"], 1, true);
            }
        }

        this._fairyDustEmitter.emit = true;
    }

    animateIn(callback, scope) {
        if (this.parent === null) return;

        super.animateIn();

        let to = this._panel.y;
        this._panel.y += 140;
        new P3.utils.TWEEN.Tween(this._panel, this._tweens)
            .to({y: to}, 340)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .delay(120)
            .start();

        this._panel.scale.set(0);
        new P3.utils.TWEEN.Tween(this._panel.scale, this._tweens)
            .to({x: 1, y: 1}, 400)
            .easing(P3.utils.TWEEN.Easing.Back.Out)
            .delay(120)
            .onStart(() => {
                this._panel.visible = true;
            })
            .start();

        to = this._progress.y;
        this._progress.y += 80;
        new P3.utils.TWEEN.Tween(this._progress, this._tweens)
            .to({y: to}, 320)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .delay(340)
            .start();

        this._progress.alpha = 0;
        new P3.utils.TWEEN.Tween(this._progress, this._tweens)
            .to({alpha: 1}, 200)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(360)
            .onStart(() => {
                this._progress.visible = true;
            })
            .onComplete(() => {
                new P3.utils.TWEEN.Tween(this._progress.fill.mask.scale, this._tweens)
                    .to({x: this._xp.to}, 1000)
                    .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
                    .delay(80)
                    .start();

                for (let i = 0; i < this._shields.length; ++i) {
                    const shield = this._shields[i];
                    if (common.location.training) {
                        shield.fill.scale.set(0);
                        new P3.utils.TWEEN.Tween(shield.fill.scale, this._tweens)
                            .to({x: 1, y: 1}, 320)
                            .easing(P3.utils.TWEEN.Easing.Back.Out)
                            .delay(i * 80)
                            .onStart(() => {
                                shield.fill.visible = true;
                            })
                            .start();
                    } else {
                        switch (common.difficulty.levelChange) {
                            case -1 : {
                                shield.fill.scale.set(1);
                                new P3.utils.TWEEN.Tween(shield.fill.scale, this._tweens)
                                    .to({x: 0, y: 0}, 320)
                                    .easing(P3.utils.TWEEN.Easing.Back.In)
                                    .delay(i * 80)
                                    .onComplete(() => {
                                        shield.fill.visible = false;
                                    })
                                    .start();
                                break;
                            }
                            case 1 : {
                                shield.fill.scale.set(0);
                                new P3.utils.TWEEN.Tween(shield.fill.scale, this._tweens)
                                    .to({x: 1, y: 1}, 320)
                                    .easing(P3.utils.TWEEN.Easing.Back.Out)
                                    .delay(i * 80)
                                    .onStart(() => {
                                        shield.fill.visible = true;
                                    })
                                    .start();
                                break;
                            }
                        }
                    }
                }
            })
            .start();
    }

    update() {
        super.update();

        const dt = window.dt;
        const settings = common.gmi.getAllSettings();

        if (settings.motion) {
            this._fairyDustEmitter.update(dt);
        }
    }

    initPanel() {
        this._panel = new PIXI.Sprite(P3.assets.texture("ui_results_panel"));
        this._panel.position.set(common.STAGE_WIDTH * 0.5, P3.View.height * 0.5);
        this._panel.anchor.set(0.5);
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.title = new PIXI.Container();
        this._panel.title.position.set(0, -170);
        this._panel.addChild(this._panel.title);

        this._panel.title.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_results_location_title"), 60, 0, 60, 0);
        this._panel.title.image.pivot.set(this._panel.title.image.width * 0.5, this._panel.title.image.height * 0.5);
        this._panel.title.addChild(this._panel.title.image);

        this._panel.title.label = new PIXI.extras.BitmapText(common.location.name, {font: "36px BBC Reith Sans", align: "center"});
        this._panel.title.label.anchor.set(0.5);
        this._panel.title.label.maxWidth = 450;
        this._panel.title.label.tint = 0xFFFFFF;
        this._panel.title.addChild(this._panel.title.label);

        this._panel.title.image.width = this._panel.title.label.textWidth * 1.4;
        this._panel.title.image.pivot.x = this._panel.title.image.width * 0.5;

        this._panel.scoreValueLabel = new PIXI.extras.BitmapText("Score " + this._score + "/" + this._total, {
            font: "36px BBC Reith Sans Large", align: "center"
        });
        this._panel.scoreValueLabel.position.set(0, -60);
        this._panel.scoreValueLabel.anchor.set(0.5);
        this._panel.scoreValueLabel.tint = 0xFFFFFF;
        this._panel.addChild(this._panel.scoreValueLabel);

        this._panel.answers = new PIXI.Container();
        this._panel.answers.position.set(0, -4);
        this._panel.addChild(this._panel.answers);

        const tickSpacing = 42;

        for (let i = 0; i < this._answers.length; ++i)
        {
            const texture = this._answers[i] ? P3.assets.texture("ui_icon_question_passed") : P3.assets.texture("ui_icon_question_failed");
            const tick = new PIXI.Sprite(texture);
            tick.position.set(i * tickSpacing - ((this._answers.length - 1) * tickSpacing) * 0.5, 0);
            tick.anchor.set(0.5);
            this._panel.answers.addChild(tick);
        }

        this._panel.level = new PIXI.Sprite(P3.assets.texture("ui_results_shield_bg"));
        this._panel.level.position.set(0, 100);
        this._panel.level.anchor.set(0.5);
        this._panel.addChild(this._panel.level);

        const level = common.difficulty.levelUnclamped;
        const change = common.difficulty.levelChange;
        console.log(level, change);

        const count = !common.location.training ? 4 : 1;
        const spacing = 94;
        for (let i = 0; i < count; ++i) {
            const shield = new PIXI.Sprite(P3.assets.texture(common.location.images.result_shield_off));
            shield.position.set(spacing * i - (spacing * (count - 1)) * 0.5, 0);
            shield.anchor.set(0.5);
            this._panel.level.addChild(shield);

            shield.fill = new PIXI.Sprite(P3.assets.texture(common.location.images.result_shield_on));
            shield.fill.anchor.set(0.5);
            shield.fill.visible = false;
            shield.addChild(shield.fill);

            if (common.location.training) {
                this._shields.push(shield);     // for training we always push the shield to animate
            } else {
                // ugly code but it works
                switch (change) {
                    case 0 : {
                        if (i < level)
                            shield.fill.visible = true;
                        break;
                    }
                    case -1 : {
                        if (i <= level)
                            shield.fill.visible = true;

                        i === level && this._shields.push(shield);
                        break;
                    }
                    case 1 : {
                        if (i < level - 1)
                            shield.fill.visible = true;

                        i === level - 1 && this._shields.push(shield);
                        break;
                    }
                }
            }
        }
    }

    initProgressBar() {
        this._progress = new PIXI.Sprite(P3.assets.texture("ui_xp_bg"));
        this._progress.position.set(common.STAGE_WIDTH * 0.5, 640);
        this._progress.anchor.set(0.5);
        this._progress.visible = false;
        this.addChild(this._progress);

        this._progress.fill = new PIXI.Sprite(P3.assets.texture("ui_xp_fill"));
        this._progress.fill.anchor.set(0.5);
        this._progress.addChild(this._progress.fill);

        const width = this._progress.fill.texture.width;
        const height = this._progress.fill.texture.height;

        this._progress.fill.mask = new PIXI.Graphics();
        this._progress.fill.mask.position.set(-width * 0.5, 0);
        this._progress.fill.mask.scale.x = 0;
        this._progress.fill.mask.beginFill(0xFF0000, 1);
        this._progress.fill.mask.drawRect(0, -height * 0.5, width, height);
        this._progress.fill.mask.endFill();
        this._progress.fill.addChild(this._progress.fill.mask);

        this._progress.plaque = new PIXI.Sprite(P3.assets.texture("ui_results_xp"));
        this._progress.plaque.position.set(-this._progress.texture.width * 0.5 - 54, 0);
        this._progress.plaque.anchor.set(0.5);
        this._progress.addChild(this._progress.plaque);

        this._progress.icon = new PIXI.Sprite(P3.assets.texture("ui_results_loot_crate"));
        this._progress.icon.position.set(this._progress.texture.width * 0.5 + 50, 0);
        this._progress.icon.anchor.set(0.5);
        this._progress.addChild(this._progress.icon);

        const user = common.save.getUserData(common.userId);
        let xp = Math.round(user.totalXp);
        let size = 36;
        if (xp > common.config.game.xp_cap) {
            xp = Math.round(common.config.game.xp_cap) + "+";
            size = 32;
        }
        this._progress.xpLabel = new PIXI.extras.BitmapText(xp + "", {font: size + "px BBC Reith Sans", align: "center"});
        this._progress.xpLabel.position.set(-2, 18);
        this._progress.xpLabel.anchor.set(0.5);
        this._progress.xpLabel.tint = 0x390307;
        this._progress.plaque.addChild(this._progress.xpLabel);
    }

    playShieldLevelVO() {
        switch (common.difficulty.levelUnclamped) {
            case 1 : {
                P3.audio.playVO("vo_queen_131", 1, true);
                break;
            }
            case 2 : {
                P3.audio.playVO("vo_queen_132", 1, true);
                break;
            }
            case 3 : {
                P3.audio.playVO("vo_queen_133b", 1, true);
                break;
            }
            case 4 : {
                P3.audio.playVO("vo_queen_134b", 1, true);
                break;
            }
        }
    }
}

ResultScene.DIFFICULTY_ANIM_CHANGE_NONE = "change_none";
ResultScene.DIFFICULTY_ANIM_CHANGE_UP   = "change_up";
ResultScene.DIFFICULTY_ANIM_CHANGE_DOWN = "change_down";
